import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-2 border-border border-t-primary mx-auto"></div>
          <p className="mt-4 font-mono text-xs tracking-widest uppercase text-muted-foreground">Loading</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <>{children}</>;
}

/**
 * Like ProtectedRoute, but additionally requires the signed-in user to be an
 * admin (email on the backend's ADMIN_EMAILS allowlist). Non-admins are sent
 * to the dashboard rather than shown an error.
 */
export function AdminRoute({ children }: ProtectedRouteProps) {
  const { user, loading } = useAuth();

  if (!loading && user && !user.isAdmin) {
    return <Navigate to="/dashboard" replace />;
  }

  return <ProtectedRoute>{children}</ProtectedRoute>;
}
